module.exports = __webpack_public_path__ + "img/icon-number-zero.57727a18.svg";